import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-event-my',
  templateUrl: './event-my.component.html',
  styleUrls: ['./event-my.component.scss']
})
export class EventMyComponent implements OnInit {
  isCollapsed = true;
  constructor() { }

  ngOnInit(): void {
  }

}
